import { useState } from 'react';
import classNames from 'classnames';
import { CSSTransition, SwitchTransition } from 'react-transition-group';

import Icon from '@/components/Icon';

import styles from './index.module.scss';

export function useCarousel () {
    const [screen, _setScreen] = useState(0);
    const [direction, setDirection] = useState('slideLeft');

    function setScreen (fn) {
        _setScreen((screen) => {
            const value = typeof fn === 'function' ? fn(screen) : fn;

            updateScreen(screen, value);

            return value;
        });
    }

    function updateScreen (oldScreen, newScreen) {
        if (newScreen > oldScreen) {
            setDirection('slideLeft');
        } else {
            setDirection('slideRight');
        }

        return newScreen;
    }

    return [screen, setScreen, direction];
}

export default function Carousel ({className, title, screens = [], screen = 0, setScreen, direction}) {

    const currentScreen = screens[screen];

    let showButtons = true;

    if (typeof currentScreen === 'object') {
        showButtons = currentScreen.showButtons;
    }

    if (screens.length < 1) {
        return null;
    }

    return (
        <div className={classNames(styles.carousel, className)}>
            <div className={styles.content}>

                <h3>{title}</h3>

                <div className={classNames(styles.carouselContent, 'carouselContent', styles[direction])}>
                    <SwitchTransition>
                        <CSSTransition timeout={250} key={screen} classNames='slide'>
                            
                            <>
                                {
                                    typeof currentScreen === 'string' ? (
                                        <p>{currentScreen}</p>
                                    ) : (
                                        <div className={styles.mainScreen}>{currentScreen.screen}</div>
                                    )
                                }
                                {showButtons && <div className={styles.buttons}>
                                    <button
                                        disabled={screen - 1 < 0}
                                        className={classNames(styles.button, styles.slideButton, {
                                            [styles.disabled]: screen - 1 < 0,
                                        })}
                                        onClick={() => setScreen((screen) => Math.max(0, screen - 1))}
                                    >
                                        <Icon size={20} icon='chevron-left' />
                                    </button>

                                    {screens.map((currentScreen, i) => {

                                        let customIcon = null;
                                        if (typeof currentScreen === 'object' && currentScreen.icon) {
                                            customIcon = currentScreen.icon;
                                        }

                                        return (
                                            <div
                                                key={i} 
                                                onClick={() => setScreen(i)}
                                                className={classNames(styles.slideItem, {
                                                    [styles.slideCircle]: !customIcon,
                                                    [styles.active]: i === screen,
                                                })}
                                            >
                                                {customIcon}
                                            </div>
                                        );
                                    })}

                                    <button
                                        disabled={screen + 1 >= screens.length}
                                        className={classNames(styles.button, styles.slideButton, {
                                            [styles.disabled]: screen + 1 >= screens.length,
                                        })}
                                        onClick={() => setScreen((screen) => Math.min(screen + 1, screens.length - 1))}
                                    >
                                        <Icon size={20} icon='chevron-right' />
                                    </button>
                                </div>}
                            </>

                        </CSSTransition>
                    </SwitchTransition>
                </div>
                
            </div>
        </div>
    );
}
